import { Route, Redirect } from 'react-router-dom';
import MenuContext from '~/contexts/menuContext';
import { DesktopNavbar } from '~/components/DesktopNavbar';
import { MobileNavbar } from '~/components/MobileNavbar';
import { useContext } from 'react';
import { apmElastic } from 'helpers/apmElastic';
import { useAuth } from 'react-oidc-context';
import { PrivateRouteWrapper } from './styles';

type PrivateRouteProps = {
  component: React.ElementType;
  path?: string;
  exact?: boolean;
}

export const PrivateRoute = ({ component: Component, ...params }: PrivateRouteProps): JSX.Element => {
  const { isAuthenticated } = useAuth();
  const { menuToogle } = useContext(MenuContext);
  const isRemoteControl = !!params.path?.includes('/controle-inteligente');
  const userProfile = localStorage.getItem('@diel:profile');
  const isFullAuth = isAuthenticated && userProfile && userProfile !== '{}';

  return (
    <>
      <DesktopNavbar />
      <MobileNavbar />
      <PrivateRouteWrapper
        isMenuOpen={menuToogle}
        isRemoteControl={isRemoteControl}
        path={params.path}
      >
        <Route
          {...params}
          render={(props) => {
            if (process.env.REACT_APP_APM_ELASTIC) {
              apmElastic(props.location.pathname);
            }
            return isFullAuth ? <Component {...props} /> : <Redirect to="/logout" />;
          }}
        />
      </PrivateRouteWrapper>
    </>
  );
};
